module.exports = __webpack_public_path__ + "img/top-new.c4cb65e0.jpg";